import { useLocation } from 'react-router-dom';
/**
 * custom hook to get query params
 * https://reactrouter.com/web/example/query-parameters
 */
export const useQueryParams = (): URLSearchParams => new URLSearchParams(useLocation().search);
